var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',{staticClass:"mx-3 mb-4"},[_vm._v(_vm._s(_vm.object.title))]),_c('ul',{staticClass:"select-list"},_vm._l((_vm.object.options),function(item){return _c('li',{key:item.step,class:{active: _vm.active === item.step},on:{"click":function($event){_vm.active = item.step}}},[_vm._v(" "+_vm._s(item.label)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }